import React from 'react';
import ContentSlider from '../../../components/content-slider';
import CustomImage from '../../../components/custom-image';
import Collapse from '../../../components/collapse';
import SelfHelpGroups from '../../../content/social-development/casestudy-3/self-help-group';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';

const Casestudy3 = () => {
  const slider = {
    slides: [
      <div className="case-study-slider">
        <CustomImage
          className="custom-image"
          imageName="self-help-group.jpg"
          alt="Sel help groups"
          maxWidth="768"
        />
      </div>,
      <div className="case-study-slider">
        <CustomImage
          className="custom-image"
          imageName="self-help-group1.jpg"
          alt="Sel help groups"
          maxWidth="768"
        />
      </div>,
      <div className="case-study-slider">
        <CustomImage
          className="custom-image"
          imageName="self-help-group2.png"
          alt="Sel help groups"
          maxWidth="768"
        />
      </div>,
      <div className="case-study-slider">
        <CustomImage
          className="custom-image"
          imageName="self-help-group3.jpg"
          alt="Sel help groups"
          maxWidth="768"
        />
      </div>
    ],
  };
  return (
    <div className="container-fluid">
      <div className="social-development-container top-section">
        <ScrollPositionAnimation targetElement1="anim-ten" targetElement2="anim-eleven">
          <div className="section-inner">
            <div className="left-img">
              <div className="left-to-right anim-ten">
                <div className="desktop-img">
                  <ContentSlider
                    data={slider.slides}
                    slidesToShow={1}
                    slidesToScroll={1}
                    customClass="blue-dots-slider"
                    dots={true}
                  />
                </div>
              </div>
            </div>
            <div className="right-content p-t-0 bottom-to-top anim-eleven">
              <p className="small-text">CASE STUDY 03:</p>
              <h3 className="bold-text blue-text">ENHANCING LIVELIHOODS IN COMMUNITIES</h3>
              <div className="mobile-img">
                <ContentSlider
                  data={slider.slides}
                  slidesToShow={1}
                  slidesToScroll={1}
                  customClass="blue-dots-slider"
                  dots={true}
                />
              </div>
              <p>
                Livelihood programmes are central to the community development activities undertaken by Vedanta.
                As the largest private entity in many of the areas where we operate, community members look towards
                our organisation to improve their economic circumstances.
              </p>
              <p>
                Where possible we have tried to integrate community members into our workforce or into our supplier
                network. For others, we have established robust, tested, livelihood programmes to help individuals gain
                new skills, allowing them to add new or enhanced sources of income.
              </p>

              <Collapse labelOne="Read More" labelTwo="Read Less">
                <p>Some success stories are given below:</p>
                <p>
                  The <strong>agriculture support programme</strong> managed by the BALCO CSR team provides soil testing, fencing
                  infrastructure, fertiliser and seedbased input support, and technical training programmes. This intervention
                  has motivated several farmers to adopt modern farming techniques such as System of Rice Intensification
                  (SRI), which has doubled yields and enhanced incomes. Many farmers have also diversified their crops, further
                  enhancing family incomes.
                </p>
                <p>
                  <strong>Self-Help Groups (SHGs)</strong> are another way to empower women and enhance family incomes. Build on
                  the community-loan model, SHGs help women entrepreneurs start their own micro-enterprises – either individually or in a group. Women
                  who have participated in these programmes have started tailoring units, farms, toy making, among other endeavours. These activities have not
                  only supplemented their household incomes, but also empowered them to become independent members of society.{' '}
                </p>
                <p>
                  A third model involves the setting up of <strong>technical training centres</strong>, which
                  teach individuals the skills to become part of the modern workforce. From call centre training provided by Cairn to the vocational training programmes
                  such as plumbing, electrician, machine operators, among others – these programmes have allowed individuals to becoming primary
                  wage earners for their families. HZL’s skill development programmes have a wide range of options to cater to each segment of youth from those
                  who have attended secondary schooling to graduates, ITI & diplomaholders. Training partnerships with automobile companies such as Maruti
                  Suzuki have provided participants with a two-year ITI degree, along with a stipend.
                </p>
              </Collapse>

              <div className="blue-box">
                <p>
                  <strong>SDG Alignment</strong>
                </p>
                <ul>
                  <li>
                    <span>Goal: SDG 8-</span>  Economic Growth &amp; Decent Work for All
                  </li>
                  <li>
                    <span>Target:</span> 8.6 Reduce youth unemployment, illiteracy, unproductivity
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ScrollPositionAnimation>
      </div>
    </div>
  );
};

export default Casestudy3;
